import Blue from '~/core'
import { handleQuery } from './pagination/_pagination'
import { getQueryParam, pushQueryParam } from './helpers/_queryParams'
import { showLoader, noResults } from './helpers/_utils'
import { renderResults } from './helpers/_render'
import {
  initializeContentTypeFilters,
  initializeSortOrderFilters,
  initializePressFilters,
} from './helpers/_filterSidebar'
import store from './state/_store'
import { initPagination } from './pagination/_pagination'

new Blue({
  name: 'Search Interface',
  selector: '.search',
  setup(container) {
    const searchEndpoint = container.dataset.search
    const contentEndpoint = container.dataset.content

    if (searchEndpoint && contentEndpoint) {
      store.updateUrls('search', searchEndpoint)
      store.updateUrls('content', contentEndpoint)
      const searchInput = container.querySelector('#query__input')
      const searchSubmit = container.querySelector('#search_submit')

      const searchResultsWrapper = container.querySelector('.results')

      const filterContentType = container.querySelectorAll('[name="filterText"]')
      const filterSortOrder = container.querySelectorAll('[name="selectedSort"]')
      const filterPressReleases = container.querySelectorAll('.filter__item-select select')
      store.search.nonce = searchInput.dataset.nonce
      store.search.token = searchInput.dataset.token

      store.subscribe(searchResultsWrapper, 'displayResults', function (results, action, store) {
        const currentQuery = getQueryParam('q')
        let hpQuery = getQueryParam('hp')
        let hpfields = document.querySelectorAll('input.hpkey')
        hpfields.forEach((item) => {
          if (item.value) {
            store.search.hp = item.value
          } else if (hpQuery) {
            item.value = hpQuery
            store.search.hp = hpQuery
          }
        })

        store.search.token = searchInput.dataset.token

        if (results && results.length > 0) {
          renderResults(results, this, currentQuery, container)
        } else {
          noResults(container)
        }
        // swap back to show the results
      })

      initializeContentTypeFilters(filterContentType, container)
      initializeSortOrderFilters(filterSortOrder, container)
      initializePressFilters(filterPressReleases, container)

      const currentQuery = getQueryParam('q')
      let hpQuery = getQueryParam('hp')
      const currentFilter = getQueryParam('filterText')
      const currentSort = getQueryParam('selectSort')

      if (currentQuery) {
        searchInput.value = currentQuery
        showLoader(container)

        let hpfields = document.querySelectorAll('input.hpkey')
        hpfields.forEach((item) => {
          if (item.value) {
            store.search.hp = item.value
          } else if (hpQuery) {
            item.value = hpQuery
            store.search.hp = hpQuery
          }
        })

        handleQuery(currentQuery, { filterText: currentFilter, selectSort: currentSort }, true)
      }

      searchInput.addEventListener('keydown', (event) => {
        const query = searchInput.value.trim()

        if (event.key === 'Enter' || event.keyCode === 13) {
          event.preventDefault()
          if (event.target?.value && query) {
            showLoader(container)
            pushQueryParam('q', query)

            let hpfields = document.querySelectorAll('input.hpkey')
            hpfields.forEach((item) => {
              if (item.value) {
                store.search.hp = item.value
              }
            })

            handleQuery(query)
          }
        }
      })

      searchSubmit.addEventListener('click', (event) => {
        const query = searchInput.value.trim()
        if (query) {
          event.preventDefault()
          showLoader(container)
          pushQueryParam('q', query)

          let hpfields = document.querySelectorAll('input.hpkey')
          hpfields.forEach((item) => {
            if (item.value) {
              store.search.hp = item.value
            }
          })

          handleQuery(query)
        }
      })

      initPagination()
    }
  },
})
